import classes from './ReportResult.module.css';
import trophy from 'assets/roleplay/trophy.png';
import chat_green from 'assets/roleplay/chat_green.png';
import { Skeleton } from '@material-ui/lab';
const Strengths = ({ className = "", title = "Strengths", summary = {}, isLoadingResponse = false, handleSeek = () => null }) => {
  function convertTimestamp(timestamp) {
    const totalSeconds = parseFloat(timestamp);

    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    const wholeSeconds = Math.floor(seconds);
    const milliseconds = Math.round((seconds - wholeSeconds) * 100);

    const formattedSeconds = String(wholeSeconds).padStart(2, '0');
    const formattedMilliseconds = String(milliseconds).padStart(2, '0');

    return `${minutes}:${formattedSeconds}:${formattedMilliseconds}`;
  }

  if (summary && summary?.strengths?.length > 0)
    return (
      <div className={className}>
        <h4>💪 {title}</h4>
        {isLoadingResponse ? (
          <div className={classes.overallFeedback}>
            <Skeleton
              variant="rect"
              width="100%"
              height="10vh"
              style={{ borderRadius: '0.5rem' }}
            />
          </div>
        ) : (
          <div className={classes.containerPractice}>
            {summary?.strengths?.map((item, index) => {
              return (
                <div key={`Strengths-${index}`} className={classes.strengths}>
                  {typeof item === 'string' ? (
                    <div className={classes.item}>
                      <div>
                        <img src={trophy} alt="text" />
                      </div>
                      <div>{item}</div>
                    </div>
                  ) : (
                    <>
                      <div className={classes.item}>
                        <img src={trophy} alt="text" /> <p>{item?.strength}</p>
                      </div>
                      <div className={classes.item}>
                        <img src={chat_green} alt="chat_strengths" />
                        <p>
                          You said:
                          <span className={classes.suggestion}>
                            {` ${item?.what_rep_said} at `}
                            <span
                              style={{
                                color: '#007bff',
                                cursor: 'pointer',
                                textDecoration: 'underline',
                              }}
                              onClick={() => handleSeek(item?.timestamp)}
                              title="Click to jump to this moment"
                            >
                              {convertTimestamp(item?.timestamp)}
                            </span>
                          </span>
                        </p>
                      </div>
                      <div className={classes.itemStrengths}>
                        <p>
                          Why this helps:
                          <span className={classes.helpText}>{` ${item?.why_a_strength}`}</span>
                        </p>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );

  return null;
};

export default Strengths;
